import React from 'react';
import classNames from 'classnames';

import InputText from '../../../FormFields/Text';
import InputSelect from '../../../FormFields/Select';
import Checkbox from '../../../FormFields/Checkbox';
import withSectionActions from '../withSectionActions';
import { fontSizeOptions } from '../../../../Models/Section';
import { SCORE_OPTIONS_AVERAGE, COLUMNS_OPTIONS } from '../../../../Context/DynamicFormContext';
import ConfigService from '../../../../Services/api/Config';

import './style.scss';
import Utils from "../../../../Services/Utils";
import WrapperWidgetIcon, {CLONE_ICON, DELETE_ICON, DOT_ICON, EDIT_ICON, RIGHT_ARROW_ICON} from "../WrapperWidgetIcon";
import MouseAndKeyboardCloseHandler from "../../../Common/MouseAndKeyboardCloseHandler";
import Button from "../../../Common/Button";

export class WidgetCollapsable extends React.PureComponent {

  getDomElement = () => this.$el;

  actionAndClose = async (fn) => {
    const { closeDialog } = this.props;
    const preventClose = fn();
    if (!preventClose) {
      closeDialog();
      return;
    }
    const result = await preventClose;
    if (result) {
      closeDialog();
    }
  };

  componentDidUpdate = async (prevProps) => {
    const { setLocaleValuesonDefaultParameters, section } = this.props;
    if (prevProps.showDialog !== this.props.showDialog && (section.created_in_language || section.updated_in_language)) {
         if(this.props.showDialog){
            setLocaleValuesonDefaultParameters();
         }
    }
  };

  checkLabelValidation = (value) => {
    const {api, section} = this.props;
    const sections = api.getAllSections();
    for (const element of sections) {
      if (element.label && element.label.toLowerCase() === value.toLowerCase() && element.id !== section.id) {
        return 'This field can not be repeated.';
      }
    }
    return '';
  };

  renderConfigTab = (internalSection, changeSectionValue, changeSectionError) => {
    const {api} = this.props;
    return (
      <div className="Widget_Form_Config">
        <InputText
          label="Label"
          required
          value={api ?  api.getFieldsVerbiage(internalSection, 'label') : internalSection.label}
          onChange={(v) => changeSectionValue('label', v)}
          error={internalSection.errors['label']}
          onError={(error) => changeSectionError('label', error)}
          validators={[this.checkLabelValidation]}
        />
        <InputSelect
          label="Number of columns (Desktop)"
          value={internalSection.columns}
          onChange={(v) => changeSectionValue('columns', v)}
          options={COLUMNS_OPTIONS}
        />
        <InputSelect
          label="Font size"
          value={internalSection.fontSize}
          onChange={(v) => changeSectionValue('fontSize', v)}
          options={fontSizeOptions()}
        />
        <InputSelect
          label="Score type"
          value={internalSection.scoreType}
          onChange={(v) => changeSectionValue('scoreType', v)}
          options={SCORE_OPTIONS_AVERAGE}
        />
        <div className="InputCheckboxesWrapper">
          <Checkbox
            onChange={(v) => changeSectionValue('hide', v)}
            label="Hide header"
            checked={internalSection.hide}
            className="InputCheckbox_Block"
          />
          <Checkbox
            onChange={(v) => changeSectionValue('cloneEnabled', v)}
            label="Cloning enabled"
            checked={internalSection.cloneEnabled}
            className="InputCheckbox_Block"
          />
          <Checkbox
            onChange={(v) => changeSectionValue('bold', v)}
            label="Bold"
            checked={internalSection.bold}
            className="InputCheckbox_Block"
          />
          <Checkbox
            onChange={(v) => changeSectionValue('italic', v)}
            label="Cursive"
            checked={internalSection.italic}
            className="InputCheckbox_Block"
          />
        </div>
        <div className="InputCheckboxesWrapper">
          <Checkbox
            onChange={(v) => changeSectionValue('lockDDR', v)}
            label="Lock in DDR"
            checked={internalSection.lockDDR}
            className="InputCheckbox_Block"
          />
          <Checkbox
            onChange={(v) => changeSectionValue('lockLabel', v)}
            label="Lock Label"
            checked={internalSection.lockLabel}
            className="InputCheckbox_Block"
          />
        </div>
      </div>
    );
  };

  renderButton = (text, fn, className = '', display = true) => {
    return (
      <Button display={display} className={`Button_Small ${className}`} onClick={() => this.actionAndClose(fn)} btnText={text} />
    );
  }

  showPlaceholder = (provider) => {
    return (provider && provider.placeholder && provider.placeholder.props && !Utils.isNull(provider.placeholder.props.on));
  };

  renderLeftActionButtons = () => {
    const {onCollapse, section, isOpen, preventDelete } = this.props;
    return (
      <div className={'CollapsableHeader__Header__Actions'}>
        <div
          className={'CollapsableHeader__Header__Button'}
        >
          <WrapperWidgetIcon display type={DOT_ICON} opacity={ (preventDelete || isOpen) ? 0.2 : 1}/>
        </div>
        <div
          className={'CollapsableHeader__Header__Button Pointer'}
          onClick={() => onCollapse(section.id)}
        >
          <WrapperWidgetIcon
            display
            type={RIGHT_ARROW_ICON}
            className={classNames('Collapsable_Arrow_Icon', {
              'Collapsable_Arrow_Icon_Open':isOpen
              })
            }
          />
        </div>
      </div>
    )
  };

  renderRightActionButtons = () => {
    const {handleClone, handleDelete, toggleDialog, preventDelete} = this.props;
    return (
      <div className={'CollapsableHeader__Header__Actions'}>
        <div
          className={'CollapsableHeader__Button SideMargin Pointer'}
          onClick={toggleDialog}
        >
          <WrapperWidgetIcon display type={EDIT_ICON}/>
        </div>
        <div
          className={'CollapsableHeader__Header__Button SideMargin Pointer'}
          onClick={handleClone}
        >
          <WrapperWidgetIcon display type={CLONE_ICON}/>
        </div>
        { !preventDelete &&
          <div
            className={'CollapsableHeader__Header__Button Pointer'}
            onClick={handleDelete}
          >
            <WrapperWidgetIcon display type={DELETE_ICON}/>
          </div>
        }
      </div>
    )
  }

  render = () => {
    const {section, preventDelete, renderForm, handleDelete, handleCancel, handleSubmit, showDialog, isOpen, className, api, languageShown } = this.props;
    const labelStyle = {
      fontSize: (section && section.fontSize) ? section.fontSize.label : null,
      color: ConfigService.getColor('tertiaryColor')
    }
    const bold = Boolean(section ? section.bold : false);
    const italic = Boolean(section ? section.italic : false);

    const children = section && section.fields && section.fields.order ? section.fields.order.length : 0;
    return (
      <>
        <div className={classNames('CollapsableHeader__Header', {
          'CollapsableHeader__Header_Open': isOpen,
          'Draggable': !preventDelete && !isOpen
        }, className)}
        >
          {this.renderLeftActionButtons()}
          <div
            style={labelStyle}
            className={classNames('Widget_Label', {bold, italic}, 'CollapsableHeader__Header__Label')}
          >
            {section ? api.getFieldsVerbiage(section, 'label') : ''} { children > 0 ? '(' + children + ')' : ''}
          </div>
          {this.renderRightActionButtons()}
        </div>
        {showDialog && (
          <div ref={(el) => (this.$el = el)}>
            <MouseAndKeyboardCloseHandler getDomElement={this.getDomElement}
                                          onClickOutside={() => this.actionAndClose(handleCancel)}>
              <div className={`${languageShown ? "WrapperWidget_Form top-50" : "WrapperWidget_Form"}`}>
                <div className="WrapperWidget_Form_Title"
                     style={{backgroundColor: ConfigService.getColor('tertiaryColor', 0.2)}}>
                  Section Divider
                </div>
                <div className="WrapperWidget_Form_Content">{renderForm(this.renderConfigTab)}</div>
                <div className="WrapperWidget_Form_Footer Center">
                  {this.renderButton('Save', handleSubmit)}
                  {this.renderButton('Cancel', handleCancel, 'Button_Cancel')}
                  {this.renderButton('Delete', handleDelete, 'Button_Delete', !preventDelete)}
                </div>
              </div>
            </MouseAndKeyboardCloseHandler>
          </div>
        )}
      </>
    )
  }
}

export const SectionWidgetCollapsable = withSectionActions(WidgetCollapsable);
